const VIEWPORT_CONTENT = 'width=device-width,initial-scale=1.0';

function isCoarseTouchDevice() {
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}

function blurActiveElement() {
  const { activeElement } = document;
  if (activeElement instanceof HTMLElement && activeElement !== document.body) {
    activeElement.blur();
  }
}

function resetViewportScale() {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  blurActiveElement();

  meta.setAttribute('content', `${VIEWPORT_CONTENT},maximum-scale=1.0`);
  void document.documentElement.offsetHeight;
  meta.setAttribute('content', VIEWPORT_CONTENT);
}

export function installIosOrientationZoomFix() {
  if (typeof window === 'undefined' || !isCoarseTouchDevice()) return;

  let timeoutId = null;

  const onOrientationChange = () => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(resetViewportScale, 150);
  };

  window.addEventListener('orientationchange', onOrientationChange);
}
